import Plugin from '@src/plugins/ckeditor5-core/src/plugin';
import {
	toWidget,
	viewToModelPositionOutsideModelElement
} from '@src/plugins/ckeditor5-widget/src/index';
import SelectFileCommand from './selectFileCommand';

export default class SelectFileEditing extends Plugin {
	static get pluginName() {
		return 'SelectFileEditing';
	}

	init() {
		const editor = this.editor;
		const schema = editor.model.schema;
		schema.register( 'selectBlock', {
			isObject: true,
			isInline: true,
			allowWhere: '$text',
			isLimit: true,
			allowAttributes: [ 'href', 'title', 'filetype', 'src', 'attachmentId' ]
		} );

		this._defineConverters();

		editor.commands.add( 'selectFile', new SelectFileCommand( editor ) );
		// 添加方法
		this.editor.editing.mapper.on(
			'viewToModelPosition',
			viewToModelPositionOutsideModelElement(
				this.editor.model,
				viewElement => viewElement.hasClass( 'ckedit-file' )
			)
		);
	}
	_defineConverters() {
		const conversion = this.editor.conversion;

		// 将 model 渲染为 HTML
		conversion.for( 'editingDowncast' ).elementToElement( {
			model: 'selectBlock',
			view: ( modelElement, { writer } ) => {
				const element = this.createDowncastElement(
					modelElement,
					writer
				);
				return toWidget( element, writer );
			}
		} );
		conversion.for( 'dataDowncast' ).elementToElement( {
			model: 'selectBlock',
			view: ( modelElement, { writer } ) => {
				return this.createDowncastElement( modelElement, writer );
			}
		} );

		// 将 HTML 渲染为 model
		conversion.for( 'upcast' ).elementToElement( {
			view: {
				name: 'a',
				classes: 'ckedit-file'
			},
			model: ( view, { writer } ) => {
				// const params = {};
				// const selectBlock = view;
				const href = view.getAttribute( 'href' );
				const title = view.getAttribute( 'title' );
				const src = view.getAttribute( 'src' );
				const filetype =
					view.getAttribute( 'data-filetype' ) || 'document';
				const attachmentId = view.getAttribute( 'attachmentId' );
				return writer.createElement( 'selectBlock', {
					href,
					title,
					filetype,
					src,
					attachmentId
				} );
			}
		} );
		conversion.for( 'upcast' ).elementToElement( {
			view: {
				name: 'iframe',
				classes: 'ckedit-file-iframe'
			},
			model: ( view, { writer } ) => {
				// const params = {};
				// const selectBlock = view;
				const href = view.getAttribute( 'href' );
				const title = view.getAttribute( 'title' );
				const src = view.getAttribute( 'src' );
				const filetype =
					view.getAttribute( 'data-filetype' ) || 'document';
				const attachmentId = view.getAttribute( 'attachmentId' );
				return writer.createElement( 'selectBlock', {
					href,
					title,
					filetype,
					src,
					attachmentId
				} );
			}
		} );
	}
	createDowncastElement( element, writer ) {
		const filetype = element.getAttribute( 'filetype' ) || 'document';
		if ( filetype == 'mp4' ) {
			// 使用 createContainerElement 创建容器元素 创建 a 标签，并设置属性
			const aElement = writer.createContainerElement( 'iframe', {
				class: 'ckedit-file ckedit-file-iframe'
			} );
			[ 'title', 'href', 'src' ].map( item => {
				writer.setAttribute( item, element.getAttribute( item ), aElement );
			} );
			if ( element.getAttribute( 'filetype' ) ) {
				writer.setAttribute(
					'data-filetype',
					element.getAttribute( 'filetype' ),
					aElement
				);
			}
			return aElement;
		} else {
			// 使用 createContainerElement 创建容器元素 创建 a 标签，并设置属性
			const aElement = writer.createContainerElement( 'a', {
				class: `ckedit-file ckedit-file-${ filetype }`
			} );
			[ 'title', 'href', 'src', 'attachmentId' ].map( item => {
				writer.setAttribute( item, element.getAttribute( item ), aElement );
			} );
			if ( element.getAttribute( 'filetype' ) ) {
				writer.setAttribute(
					'data-filetype',
					element.getAttribute( 'filetype' ),
					aElement
				);
			}
			// 判断是否可以预览 不能就下载
			const linkTypes = this.editor.config.get( 'selectFile.linkTypes' );
			if ( linkTypes.indexOf( element.getAttribute( 'filetype' ) ) !== -1 ) {
				writer.setAttribute( 'target', '_blank', aElement );
			} else {
				writer.setAttribute( 'download', 'download', aElement );
			}
			const innerText = writer.createText( element.getAttribute( 'title' ) );
			writer.insert( writer.createPositionAt( aElement, 0 ), innerText );
			return aElement;
		}
	}
}
